import React, { useState } from "react";
// import "./question.css";
import Amplify, { Auth } from 'aws-amplify';

import { css, cx } from '@emotion/css';

const overlayStyle = css`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.2s ease-out forwards;
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const modalStyle = css`
  background: #fff;
  border-radius: 20px;
  width: 90%;
  max-width: 400px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 15px 35px rgba(0,0,0,0.2);
  position: relative;
  transform: scale(0.9);
  animation: popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;

  @keyframes popIn {
    to { transform: scale(1); }
  }
`;

const closeBtnStyle = css`
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 20px;
  color: #aaa;
  cursor: pointer;
  border: none;
  background: none;
  transition: color 0.2s;
  
  &:hover {
    color: #333;
  }
`;

const titleStyle = css`
  font-family: 'Poppins', sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #333;
  margin-bottom: 15px;
`;

const textStyle = css`
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  color: #666;
  margin-bottom: 30px;
  line-height: 1.5;
`;

const actionBtnStyle = css`
  background: #2ec32b;
  color: #fff;
  border: none;
  border-radius: 25px;
  padding: 12px 0;
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 15px rgba(46, 195, 43, 0.4);
  font-family: 'Poppins', sans-serif;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(46, 195, 43, 0.6);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

function ReopenAssignment(props) {
  const [buttonText, setButtonText] = useState("ReOpen");

  const getToken = async () => {
    Auth.currentSession().then(res => {
      let accessToken = res.getAccessToken();
      let jwt = accessToken.getJwtToken();
      reopenevents1(props.category, props.eventid, jwt);
    });
  };

  const reopenevents1 = async (category, eventid, jwt) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': jwt },
      body: JSON.stringify({ category: category, event_id: eventid })
    };

    const response = await fetch(`https://api.quizwizard.net/quiz/deleteuseractivity`, requestOptions);
    const data = await response.json();
    props.closereopeneventwindow();
    setButtonText("ReOpen");
  };

  function reopenevents() {
    setButtonText("Reopening...");
    getToken();
  }

  return (
    <div className={overlayStyle} onClick={props.closereopeneventwindow}>
      <div className={modalStyle} onClick={e => e.stopPropagation()}>
        <button className={closeBtnStyle} onClick={props.closereopeneventwindow}>&#10005;</button>
        <div style={{ fontSize: '40px', marginBottom: '10px' }}>📂</div>
        <h3 className={titleStyle}>Reopen Challenge</h3>
        <p className={textStyle}>
          Are you sure you want to reopen <strong>{props.name}</strong>?
        </p>
        <button className={actionBtnStyle} onClick={reopenevents}>{buttonText}</button>
      </div>
    </div>
  );
}

export default ReopenAssignment;